const TspSupplierReportDetailsData = ({ data, id }) => {

    return (
        <>
            {
                data && data.length > 0 ? (
                    data.map((curData => {
                        return (
                            <tr key={id}>

                                <td>{curData['Questions']}</td>
                                <td>{curData['Assessed']}</td>
                                <td>{curData['Planned Comments']}</td>
                                <td>{curData['Opportunity']}</td>
                                <td>{curData['Yes']}</td>
                                <td>{curData['Mostly yes']}</td>
                                <td>{curData['Mostly no']}</td>
                                <td>{curData['No']}</td>
                                <td>{curData['Not applicable']}</td>
                                <td>{curData['Nb respondents']}</td>
                                <td>{curData['Environmental']}</td>
                                <td>{curData['Ops / maintenance']}</td>
                                <td>{curData['Financial']}</td>
                                <td>{curData['Implementation ease']}</td>
                                <td>{curData['AVERAGE VALUE']}</td>
                            </tr>
                        )
                    }))) : (
                    <span>No Tsp supplier reports details data available.</span>
                )
            }

        </>
    )
}

export default TspSupplierReportDetailsData;